<mat-card>
    <div fxLayout="row wrap">
        <form [formGroup]="registerForm" (ngSubmit)="onRegisterFormSubmit(registerForm.value)">
            <!-- <form [formGroup]="registerForm" (ngSubmit)="onRegisterFormSubmit(registerForm.value)"> -->
            <div fxFlex="100" fxFlex.gt-sm="50" class="p-2" ngClass.sm="mt-2" ngClass.xs="mt-2">
                <h2 class="text-muted text-center">Don't have an account? Sign up now!</h2>

                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>First Name</mat-label>
                    <input matInput placeholder="First Name" formControlName="firstName" required>
                    <!-- <mat-error *ngIf="registerForm.controls.name.errors?.required">First Name is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.name.hasError('minlength')">First Name isn't long enough,
                        minimum of 3 characters</mat-error> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-1">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Email" formControlName="email" required>
                    <!-- <mat-error *ngIf="registerForm.controls.email.errors?.required">Email is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.email.hasError('invalidEmail')">Invalid email address
                    </mat-error> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>Address</mat-label>
                    <input matInput placeholder="Address" formControlName="address" required>
                    <!-- <mat-error *ngIf="registerForm.controls.name.errors?.required">Address is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.name.hasError('minlength')">Address isn't long enough,
                        minimum of 10 characters</mat-error> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <label>Role</label>
                    <input matInput placeholder="Role" formControlName="roleId" required>
                    <!-- <mat-error *ngIf="registerForm.controls.name.errors?.required">Role is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.name.hasError('minlength')">Role isn't long enough,
                        minimum of 1 characters</mat-error> -->
                </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="p-2" ngClass.sm="mt-2" ngClass.xs="mt-2">
                <h2 class="text-muted text-center">&nbsp;</h2>
                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>Lat Name</mat-label>
                    <input matInput placeholder="Last Name" formControlName="lastName" required>
                    <!-- <mat-error *ngIf="registerForm.controls.name.errors?.required">Last Name is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.name.hasError('minlength')">Last Name isn't long enough,
                        minimum of 3 characters</mat-error> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>Phone</mat-label>
                    <input matInput placeholder="Phone" formControlName="phone" required>
                    <!-- <mat-error *ngIf="registerForm.controls.name.errors?.required">Phone Number is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.name.hasError('minlength')">Phone Number isn't long enough,
                        minimum of 10 characters</mat-error> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-1">
                    <mat-label>Password</mat-label>
                    <input matInput placeholder="Password" formControlName="password" type="password" minlength="6"
                        required>
                    <!-- <mat-error *ngIf="registerForm.controls.password.errors?.required">Password is required</mat-error>
                    <mat-error *ngIf="registerForm.controls.password.hasError('minlength')">Password isn't long enough,
                        minimum of 6 characters</mat-error> -->
                </mat-form-field>

                <div class="text-center fxLayoutAlign mt-2">
                    <button mat-flat-button color="primary" class="mat-elevation-z6" type="submit">
                        Register
                    </button>
                </div>
                <!--<div class="text-center mt-2">
                    <button mat-fab color="primary" class="mat-elevation-z6"
                        (click)="onRegisterFormSubmit(registerForm.value)">
                        <mat-icon>person_add</mat-icon>
                    </button>
                </div>-->
            </div>
        </form>
    </div>
</mat-card>